import { createFileRoute } from '@tanstack/react-router';
import { AccountSettings } from '@/components/settings/account-settings';
import { PageHeader } from '@/components/page-header';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute('/_auth/_side-layout/settings_/account')({
  component: AccountPage,
});

function AccountPage() {
  return (
    <>
      <PageHeader
        title="My Profile"
        description="Your personal profile details."
      />
      <PageContent>
        <AccountSettings />
      </PageContent>
    </>
  );
}
